import type {ClientTool} from '@github-ui/ahp-relay/relay-connection-runtime'

const tools = new Map<string, ClientTool>()
const listeners = new Set<() => void>()
let snapshot: ClientTool[] = []

function notify(): void {
  for (const listener of listeners) listener()
}

export function registerTool(tool: ClientTool): void {
  tools.set(tool.definition.name, tool)
  snapshot = Array.from(tools.values())
  notify()
}

export function unregisterTool(name: string, instance?: ClientTool): void {
  if (instance && tools.get(name) !== instance) return
  tools.delete(name)
  snapshot = Array.from(tools.values())
  notify()
}

export function getClientTools(): readonly ClientTool[] {
  return snapshot
}

export function subscribeTools(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Test-only: clear all registered tools. */
export function resetForTests(): void {
  tools.clear()
  snapshot = []
  notify()
}
